module.exports = __webpack_public_path__ + "static/img/iphone_ldt3_back.19acb9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldt3_back.png
// module id = Syc1
// module chunks = 0